import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
  selector: 'input[awairInput]',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})

export class InputComponent implements OnInit {
  @HostBinding('attr.placeholder') hostPlaceholder: string;

  @Input()
  set placeholder(value: string) {
    if (value) {
      this.hostPlaceholder = value;
    }
  }
  constructor() {
  }

  ngOnInit() {
  }
}
